import { Card as MantineCard } from "@mantine/core";
import classnames from "classnames";
import styles from "./card.module.scss";
import type { CustomCardFactory, IProps } from "./card.types";
import { polymorphicComponentWrapper } from "../../utilities";

/**
 * Card component.
 * @param {object} props.classNames - Custom class names combined with the default slot classes.
 * @returns {JSX.Element} The Card component.
 */
const Card = polymorphicComponentWrapper<CustomCardFactory, IProps>("Card", ({ classNames, ...props }, ref) => {
    return (
        <MantineCard
            ref={ref}
            classNames={{
                root: classnames(styles["root"], typeof classNames === "object" ? classNames?.root : ""),
                section: classnames(styles["section"], typeof classNames === "object" ? classNames?.section : ""),
            }}
            {...props}
        />
    );
});

export { Card };
